var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard"},[_c('div',{staticClass:"box mt-4"},[_c('b-tabs',[_c('b-tab',{attrs:{"title":"Annetused"}},[_c('DonationsHeatmap')],1),_c('b-tab',{attrs:{"title":"UTM kampaaniad"}},[_c('UTM')],1)],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }